import { firestore } from '../../config/firebase';
import firebase from 'firebase/app';
import 'firebase/storage';

export const CONTENT_TYPES = {
    PDF: 'pdf',
    BOOK: 'book',
    VIDEO: 'video'
};

export const TRAINING_CATEGORIES = {
    COURSE: 'course',
    TD: 'td',
    TP: 'tp',
    REFERENTIELS: 'referentiels',
    INFOS_ALERTES: 'infos_alertes'
};

const uploadFile = async (file, path) => {
    if (!file) return null;

    const storage = firebase.storage();
    const storageRef = storage.ref();
    const fileRef = storageRef.child(path);

    try {
        const snapshot = await fileRef.put(file);
        const downloadURL = await snapshot.ref.getDownloadURL();
        return downloadURL;
    } catch (error) {
        throw error;
    }
};

export const createTraining = async (trainingData, file = null) => {
    try {
        let fileUrl = null;
        let fileName = null;

        if (file) {
            const timestamp = Date.now();
            const sanitizedFileName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
            const filePath = `trainings/${timestamp}_${sanitizedFileName}`;
            fileUrl = await uploadFile(file, filePath);
            fileName = file.name;
        }

        const formationData = {
            ...trainingData,
            fileUrl,
            fileName,
            createdAt: firebase.firestore.FieldValue.serverTimestamp(),
            updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        };

        const docRef = await firestore.collection('trainings').add(formationData);

        return docRef.id;
    } catch (error) {
        throw error;
    }
};

export const updateTraining = async (trainingId, updateData, file = null) => {
    try {
        let fileUrl = updateData.fileUrl;
        let fileName = updateData.fileName;

        if (file) {
            const timestamp = Date.now();
            const sanitizedFileName = file.name.replace(/[^a-zA-Z0-9.-]/g, '_');
            const filePath = `trainings/${timestamp}_${sanitizedFileName}`;
            fileUrl = await uploadFile(file, filePath);
            fileName = file.name;
        }

        const dataToUpdate = {
            ...updateData,
            fileUrl,
            fileName,
            updatedAt: firebase.firestore.FieldValue.serverTimestamp()
        };

        await firestore.collection('trainings').doc(trainingId).update(dataToUpdate);

    } catch (error) {
        throw error;
    }
};

export const deleteTraining = async (trainingId) => {
    try {
        await firestore.collection('trainings').doc(trainingId).delete();
    } catch (error) {
        throw error;
    }
};

export const getTrainings = async (category = null) => {
    try {
        let query = firestore.collection('trainings');

        if (category) {
            query = query.where('category', '==', category);
        }

        const snapshot = await query.get();
        const trainings = [];

        snapshot.forEach(doc => {
            trainings.push({
                id: doc.id,
                ...doc.data()
            });
        });

        return trainings;
    } catch (error) {
        throw error;
    }
};

export const getTrainingById = async (trainingId) => {
    try {
        const doc = await firestore.collection('trainings').doc(trainingId).get();

        if (doc.exists) {
            return {
                id: doc.id,
                ...doc.data()
            };
        }

        return null;
    } catch (error) {
        throw error;
    }
};

export const purchaseTraining = async (userId, trainingId, price = 0) => {
    try {
        // Vérifier si l'utilisateur n'a pas déjà acheté cette formation
        const existingPurchase = await firestore.collection('userTrainings')
            .where('userId', '==', userId)
            .where('trainingId', '==', trainingId)
            .get();

        // Si déjà acheté, ne pas créer de doublon
        if (!existingPurchase.empty) {
            return;
        }

        // Créer l'enregistrement d'achat
        await firestore.collection('userTrainings').add({
            userId,
            trainingId,
            price: price || 0,
            purchasedAt: firebase.firestore.FieldValue.serverTimestamp(),
            status: 'completed',
            isFree: price === 0 || price === null || price === undefined
        });
    } catch (error) {
        throw error;
    }
};

export const hasUserPurchasedTraining = async (userId, trainingId) => {
    try {
        const snapshot = await firestore.collection('userTrainings')
            .where('userId', '==', userId)
            .where('trainingId', '==', trainingId)
            .get();

        return !snapshot.empty;
    } catch (error) {
        return false;
    }
};

export const getUserPurchasedTrainings = async (userId) => {
    try {
        const snapshot = await firestore.collection('userTrainings')
            .where('userId', '==', userId)
            .get();

        const purchasedTrainings = [];

        for (const doc of snapshot.docs) {
            const userTraining = doc.data();
            const training = await getTrainingById(userTraining.trainingId);

            if (training) {
                purchasedTrainings.push({
                    id: training.id,
                    ...training,
                    purchasedAt: userTraining.purchasedAt,
                    status: userTraining.status
                });
            }
        }

        return purchasedTrainings;
    } catch (error) {
        return [];
    }
};